import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import { GlobalEmailTemplate } from '@models/global-email-templates';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { BusinessState } from '@state/business';
import { Repo } from '../../repo.service';

@Injectable({
	providedIn: 'root',
})
export class BusinessEmailTemplateVersionsRepo extends Repo<
	GlobalEmailTemplate,
	{ templateId: string }
> {
	@SelectSnapshot(BusinessState.businessId) businessId: string;

	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}

	GetCollectionPath(pathParams: { templateId: string }): string {
		return CollectionPaths.business_email_template_versions(
			this.businessId,
			pathParams.templateId,
		);
	}
}
